module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Shorten Your URL","placeHolder":"https://some.url","empty":"Please input a URL~","already":"It\u0027s already shortened~","unknown":"Unknown error chun~","toFast":"Request too frequently, have a rest~","copy":"Copy","copied":"Copied~","failToCopy":"Failed to copy, QAQ"},"zh":{"title":"生成短网址","placeHolder":"https://某个.网址","empty":"请填写网址啾～","already":"已经是短网址啦～","unknown":"未知错误啾～","toFast":"太快啦，休息一下吧啾啾～","copy":"复制网址","copied":"复制成功啾～","failToCopy":"复制失败啾～请尝试手动复制～"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/yaml-loader!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/main.vue
// module id = 18
// module chunks = 0